<template lang="pug">
  v-container
    h1.seo-only 佑昇生殖中心掛號方式與行動 App
    v-img.rounded(src="/reserve01.png" alt="佑昇生殖中心掛號方式與行動 App 操作說明" eager contain)
</template>
<script>
export default {
  name: "HowToReserve",

  data() {
    return {};
  },
};
</script>
